module.exports = __webpack_public_path__ + "img/3x.6a2ae4c.jpg";